<template>
    <div class="mb-5">
        <div class="d-flex mb-5 ml-auto justify-content-end" v-if="!generated">
            <v-btn :color="primaryColor" class="mr-2 text-none" @click="generateContent" :disabled="loading || count >= maxCount">
                <v-icon left color="white">auto_fix_high</v-icon>
                <span class="text-white">Suggérer une description</span>
            </v-btn>

            <v-icon @click="infoModal = true" class="mt-auto mb-auto" :color="primaryColor">mdi-information</v-icon>

            <v-tooltip top v-if="count >= maxCount">
                <template #activator="{ on }">
                    <v-icon v-on="on" color="warning">warning</v-icon>
                </template>

                <div>
                    Vous avez atteint votre limite de génération de contenu.
                </div>
            </v-tooltip>
        </div>

        <v-expand-transition class="mt-5">
            <div v-if="loading" class="d-flex flex-column align-center">
                <v-progress-circular indeterminate size="50" :color="primaryColor"></v-progress-circular>
                <span class="text-primary">Nous vous préparons une suggestion de description. N’hésitez pas à l’améliorer !</span>
            </div>

            <v-alert v-else-if="errorGeneration" color="warning" type="warning">
                Nous n'avons pas assez d'informations à propos de votre établissement.
                Pour générer une description {{ typeWord }}, complétez vos informations.
            </v-alert>

            <v-alert v-else-if="generated">
                <div class="mb-5">Description suggérée :</div>

                <div class="ai-suggested-content" style="white-space: pre-wrap">{{ content }}</div>

                <div class="mt-5 text-center d-flex flex-wrap justify-center">
                    <v-btn :color="primaryColor" class="mr-2 mt-2 mb-2 text-none text-white" rounded @click="acceptContent">
                        <v-icon>done</v-icon>
                        Remplacer ma description
                    </v-btn>

                    <v-btn color="error" class="mr-2 mt-2 mb-2 text-none text-white" rounded @click="cancelGeneration">
                        <v-icon>close</v-icon>
                        Ignorer la suggestion
                    </v-btn>
                </div>
            </v-alert>
        </v-expand-transition>

        <v-dialog content-class="pro-dialog" v-model="infoModal" max-width="600px" v-if="infoModal">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <h3 class="headline-title" style="font-size: 14px">Ma suggestion n’est pas pertinente, que faire ?</h3>

                    <div>
                        La qualité de la suggestion est directement liée à la qualité des informations déjà présentes dans votre fiche.
                        Un conseil : remplissez d’abord votre fiche avec le maximum d’informations qualitatives et
                        nous pourrons ensuite vous faire une suggestion plus pertinente.
                    </div>

                    <h3 class="mt-4 headline-title" style="font-size: 14px">Est-ce illimité ?</h3>

                    <div>
                        Non, vous pouvez utiliser ce service jusqu’à <strong>5 fois maximum</strong>.
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ContentAI",
    props: ['type', 'typeWord'],
    data() {
        return {
            content: null,
            loading: false,
            generated: false,
            count: 0,
            maxCount: 5,
            infoModal: false
        }
    },
    methods: {
        generateContent() {
            let payload = {
                name : this.provider.name,
                category : this.provider.category.label,
                commune : this.provider.localisation.commune.name,
                services : this.provider.elements.map(service => service.label),
                type: this.type
            }

            this.loading = true
            this.generated = false

            this.$http.post('textual/generate-description', payload).then(res => {
                this.content = res.body.data.content

                this.count++
                this.loading = false
                this.generated = true

                this.$store.dispatch('tracking/createTracking', ['GENERATE_CONTENT_AI', this.model, this.instanceId])
            })
        },
        cancelGeneration() {
            this.content = null
            this.generated = false

            this.$store.dispatch('tracking/createTracking', ['REFUSE_CONTENT_AI', this.model, this.instanceId])
        },
        acceptContent() {
            this.$global.$emit('accept-ai-content', {
                type: this.type,
                content: this.content
            })

            this.generated = false

            this.$store.dispatch('tracking/createTracking', ['ACCEPT_CONTENT_AI', this.model, this.instanceId])
        }
    },
    computed: {
        ...mapState("web_form", ["provider", "id"]),
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
        errorGeneration() {
            return this.generated && (this.content === '' || this.content === null)
        },
        instanceId() {
            return this.id ?? this.provider.id
        },
        model() {
            return this.id ? "WEB_FORM" : "PROVIDER"
        }
    }
}
</script>